<h1 mat-dialog-title>DELETE {{title}}</h1>
<div mat-dialog-content>
  <p>{{message}}</p>
</div>
<div mat-dialog-actions class="float-right">
  <button mat-button (click)="modalRemoveSessionCancel()">CANCEL</button>
  <button mat-button [ngClass]="{'hidden': canDelete==false}"  (click)="removeSession(session)" cdkFocusInitial>YES</button>
</div>